import React, { useContext } from 'react';

import { FinanceProcessContext } from 'features/brazil-grower/pages/BrazilGrowersDetail';
import i18next from 'i18next';
import { LoadingIndicator, NoResultsFound } from 'shared';
import { getBackgroundCheckMap } from '../BrazilGrowerFinance/utils/backgroundCheck.util';
import { BrazilGrowerContactsList } from './BrazilGrowerContactsList';

export const BrazilGrowerGeneralInformation = () => {
  const { contactRolesBackgroundChecksQuery } = useContext(FinanceProcessContext);

  if (contactRolesBackgroundChecksQuery?.error) {
    return <p>{i18next.t('error')}</p>;
  }

  if (contactRolesBackgroundChecksQuery?.loading) {
    return <LoadingIndicator />;
  }

  if (!contactRolesBackgroundChecksQuery?.data?.opportunityContactRoles) {
    return <NoResultsFound />;
  }

  const backgroundChecks = contactRolesBackgroundChecksQuery?.data?.backgroundCheckGroup?.backgroundChecks ?? [];
  const backgroundCheckMap = getBackgroundCheckMap(backgroundChecks);

  return (
    <BrazilGrowerContactsList
      opportunityContactRoles={contactRolesBackgroundChecksQuery.data.opportunityContactRoles}
      backgroundCheckMap={backgroundCheckMap}
    />
  );
};
